module.exports = __webpack_public_path__ + "static/media/icon_wifi_black.122a048c.png";